import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import MainContent from './MainContent'
import { Helmet } from 'react-helmet'

const Itemgroup = () => {
  
  return (
    <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
        <Helmet>
				<title>Item Group List</title>
			</Helmet>
      <Header />
    <MainContent />
    </div>
  )
}

export default Itemgroup